import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        color: "#999",
        display: "flex",
        justifyContent: "center",
        alignItem: "center",
        margin: "10px",
      }}
    >
      <strong>
        Made With <span style={{ color: "red" }}>❤</span> by jahidul islam
      </strong>
    </div>
  );
};

export default Footer;
